<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-doe-dialog-create
          v-if="$hasPermissionTo(['create DoEs'])"
          @created="loadDoEs"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="DoE's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in DoE here"
          append-icon="search"
          label="Search DoE"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <!-- do not remove the border='' below -->
    <!-- css purpose -->
    <v-data-table
      border=""
      :headers="headers"
      :items="filteredDoEs"
      :loading="tableLoading"
      :search="search"
      :single-expand="true"
      show-expand
      class="remove-box-shadow"
    >
      <template v-slot:item.description="{ item }">
        <span v-html="item.description" />
      </template>

      <template v-slot:item.payroll_cycle="{ item }">
        <span>
          {{ item.payroll_cycle.name ? item.payroll_cycle.name : 'N/A' }}
        </span>
      </template>

      <template v-slot:item.doe_category="{ item }">
        <span>
          {{ item.doe_category.name ? item.doe_category.name : 'N/A' }}
        </span>
      </template>

      <template v-slot:item.cutoff_type="{ item }">
        <span>
          {{ item.cutoff_type.name ? item.cutoff_type.name : 'N/A' }}
        </span>
      </template>
      
      <template v-slot:item.tax_exemption="{ item }">
        <span>
          {{ item.tax_exemption? item.tax_exemption.name : 'N/A' }}
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-payroll-doe-dialog-create-multiple
            v-if="$hasPermissionTo(['update DoEs'])"
            :doe="item"
            @created="refreshData"
          />
          <setup-payroll-doe-dialog-edit
            v-if="$hasPermissionTo(['update DoEs'])"
            :doe="item"
            @updated="refreshData"
          />
          <setup-payroll-doe-dialog-delete
            v-if="$hasPermissionTo(['delete DoEs']) && $vuetify.breakpoint.mdAndUp"
            :doe="item"
            @deleted="refreshData"
          />
          <setup-payroll-doe-dialog-delete-mobile
            v-if="$hasPermissionTo(['delete DoEs']) && $vuetify.breakpoint.smAndDown"
            :doe="item"
            @deleted="refreshData"
          />
        </span>
        <span v-else>
          <setup-payroll-doe-dialog-restore
            v-if="$hasPermissionTo(['restore DoEs']) && $vuetify.breakpoint.mdAndUp"
            :doe="item"
            @restored="refreshData"
          />
          <setup-payroll-doe-dialog-restore-mobile
            v-if="$hasPermissionTo(['restore DoEs']) && $vuetify.breakpoint.smAndDown"
            :doe="item"
            @restored="refreshData"
          />
        </span>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="py-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <v-row>
            <v-col
              cols="6"
              xl="6"
              lg="6"
              md="12"
              sm="12"
            >
              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">Negative?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_negative ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">Taxable?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_taxable ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">EPF?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_epf ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">SOCSO?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_socso ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">EIS?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_eis ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">HRDF?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_hrdf ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="6"
                  xl="4"
                  lg="4"
                  md="4"
                  sm="4"
                >
                  <span class="font-weight-bold">Additional Remuneration?</span>
                </v-col>
                <v-col cols="1">
                  :
                </v-col>
                <v-col
                  cols="5"
                  xl="1"
                  lg="1"
                  md="1"
                  sm="1"
                >
                  <v-icon medium>
                    {{ item.is_additional_remuneration ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="6"
              xl="6"
              lg="6"
              md="12"
              sm="12"
            >
              <v-row no-gutters>
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                >
                  <span class="font-weight-bold">Description:</span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                >
                  <span v-html="item.description" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    <span class="subtitle-2 font-weight-medium font-italic">
      <div>
        <span class="font-weight-bold">Legend: </span>
        <span class="font-weight-bold">EA</span> = EA Class
      </div>
    </span>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollDoeDialogCreate: () => import('@/components/hris/setup/payroll/doe/DialogCreate'),
      SetupPayrollDoeDialogEdit: () => import('@/components/hris/setup/payroll/doe/DialogEdit'),
      SetupPayrollDoeDialogDelete: () => import('@/components/hris/setup/payroll/doe/DialogDelete'),
      SetupPayrollDoeDialogDeleteMobile: () => import('@/components/hris/setup/payroll/doe/DialogDeleteMobile'),
      SetupPayrollDoeDialogRestore: () => import('@/components/hris/setup/payroll/doe/DialogRestore'),
      SetupPayrollDoeDialogRestoreMobile: () => import('@/components/hris/setup/payroll/doe/DialogRestoreMobile'),
      SetupPayrollDoeDialogCreateMultiple: () => import('@/components/hris/setup/payroll/doe/DialogCreateMultiple'),
    },
    data () {
      return {
        expanded: [],
        DoEs: [],
        trashedDoEs: [],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Payroll Cycle',
            align: 'left',
            value: 'payroll_cycle',
          },
          {
            text: 'DOE Category',
            align: 'left',
            value: 'doe_category',
          },
          {
            text: 'Cutoff Type',
            align: 'left',
            value: 'cutoff_type',
          },
          {
            text: 'Tax Exemption',
            align: 'left',
            value: 'tax_exemption',
          },
          {
            text: 'EA',
            align: 'left',
            value: 'ea_class',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: false,
      }
    },
    computed: {
      filteredDoEs () {
        return this.statusFilter ? this.DoEs : this.trashedDoEs
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadDoEs () {
        this.tableLoading = true

        this.$api.deductionOrEarnings().list()
          .then(response => {
            this.DoEs = _.orderBy(response.data, ['code'], ['asc'])

            this.tableLoading = false
          })
      },
      loadTrashedDoEs () {
        this.$api.deductionOrEarnings().listTrashed()
          .then(response => {
            this.trashedDoEs = response.data
          })
      },
      refreshData () {
        this.loadDoEs()
        this.loadTrashedDoEs()
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px
}

.remove-box-shadow >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__content{
  box-shadow: unset !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row{
  background-color: rgba(0, 0, 0, .05) !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-start{
  border:0px !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-left{
  border:0px !important;
}
</style>
